import React from 'react';
import { useTranslation } from 'react-i18next';
import { RecommendedProduct } from 'store/product/types';
import styles from './YouWillAlsoLikeProduct.module.scss';

export interface Props {
  product: RecommendedProduct;
}

const YouWillAlsoLikeProduct = ({ product }: Props) => {
  const { t } = useTranslation();
  const hasDiscount = product.initialPrice.formatted !== product.finalPrice.formatted;

  return (
    <a href={product.referenceUrl} className={styles.productItem}>
      <div className={styles.imageContainer}>
        <img src={product.imageUrl} alt="" />
      </div>
      <div className={styles.title}>{product.title}</div>
      <div>
        {t('txt_from')}
        &nbsp;
        {hasDiscount && (
          <>
            <span className={styles.oldPrice} dangerouslySetInnerHTML={{ __html: product.initialPrice.formatted }} />
            <span
              className={styles.discountedPrice}
              dangerouslySetInnerHTML={{ __html: product.finalPrice.formatted }}
            />
          </>
        )}
        {!hasDiscount && (
          <span className={styles.regularPrice} dangerouslySetInnerHTML={{ __html: product.finalPrice.formatted }} />
        )}
      </div>
    </a>
  );
};

export default YouWillAlsoLikeProduct;
